import dmsLogoBlue from '../assets/logos/DMSLogoBlue.svg';

export const GameListCopy = [
  {
    id: 1,
    name: 'The Pandemic Game',
    url: 'pandemic_game',
    imgUrl:
      'https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80',
    imgAlt: 'A microscopic view of the covid-19 bug',
    policyFocus: ['Public health'],
    skillsFocus: [
      'Crisis management',
      'Multi-party negotiation',
      'Social dilemma',
      'Communication',
    ],
    description:
      'In this time-sensitive simulation, teams manage economic and public health impacts of a deadly disease. Participants hone skills in crisis management, multi-party negotiation, and communication, working within and between teams to devise a response to the outbreak.',
    beta: false,
    gameLinkUrl: 'https://pandemic2.dmsi-sims.com/',
    gameLinkCopy: 'Access simulation',
    downloadLinks: [
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/pandemic-2-instructor-manual.pdf',
        linkCopy: 'Instructor manual',
      },
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/pandemic-2-player-manual.pdf',
        linkCopy: 'Player manual',
      },
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/Pandemic_instructor_quickstart.pdf',
        linkCopy: 'Instructor quickstart',
      },
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/Pandemic_player_quickstart.pdf',
        linkCopy: 'Player quickstart',
      },
    ],
  },
  {
    id: 2,
    name: 'Metropolitan: A Sustainable Transit Simulation',
    url: 'metropolitain',
    imgUrl:
      'https://images.unsplash.com/photo-1580164158471-b5595cf4299a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80',
    imgAlt: 'A microscopic view of the covid-19 bug',
    policyFocus: [
      'Sustainability',
      'Housing, transit, and employment access',
      'Land use',
    ],
    skillsFocus: [
      'Multi-party negotiation',
      'Data Analysis',
      'Distributive & integrative issues',
    ],
    description:
      'City government officials must plan a policy approach to lower citywide CO2 output. With conflicting and overlapping goals, participants negotiate decisions like density, housing policies, charging stations, bus lanes, and whether to plant street trees.',
    beta: true,
    gameLinkUrl: 'https://metro.dmsi-sims.com/',
    gameLinkCopy: 'Access simulation',
    downloadLinks: [
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/Metropolitan+Instructor+Manual+22.11.07.pdf',
        linkCopy: 'Instructor manual',
      },
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/Metropolitan+Player+Manual+22.11.07.pdf',
        linkCopy: 'Player manual',
      },
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/Policy+Dictionary+22.11.07.pdf',
        linkCopy: 'Policy Dictionary',
      },
    ],
  },
  {
    id: 3,
    name: 'Host Nations: A Refugee Simulation',
    url: 'host_nations',
    imgUrl:
      'https://images.unsplash.com/photo-1619569124496-4f35021bdbf1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
    imgAlt: 'A wide view of a refugee camp',
    policyFocus: ['Migration'],
    skillsFocus: [
      'Multi-party & bilateral negotiation',
      'Data analysis',
      'Consensus-building',
      'Trade-offs (long-term vs short-term',
    ],
    description:
      'Faced with a migrant influx, teams negotiate a regional response, allocate limited resources, and weigh short-terms costs against long-term benefits.',
    beta: false,
    gameLinkUrl: 'https://hostnations.dmsi-sims.com/',
    gameLinkCopy: 'Access simulation',
    downloadLinks: [
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/Host+Nations+Instructor+Manual+22.11.04.pdf',
        linkCopy: 'Instructor manual',
      },
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/Host+Nations+Player+Manual+22.11.04.pdf',
        linkCopy: 'Player manual',
      },
      {
        linkUrl:
          'https://dmsi-portal-documents.s3.amazonaws.com/HN+Policy+Dictionary+22.11.04.pdf',
        linkCopy: 'Policy Dictionary',
      },
    ],
  },
];

// Kept separate from legacy game-code products; Home adds this for superusers.
export const SimsEngineCopy = {
  id: 'sims-engine',
  name: 'Sims Engine',
  imgUrl: dmsLogoBlue,
  imgAlt: 'DMS International',
  imageFit: 'contain',
  policyFocus: ['Public policy'],
  skillsFocus: ['Multi-party negotiation', 'Information sharing', 'Decision-making'],
  description: 'Create and facilitate multi-party negotiation simulations. Access is currently limited to portal superusers.',
  beta: false,
  gameLinkUrl: 'https://sims-engine.dmsi-sims.com/signin',
  gameLinkCopy: 'Open Sims Engine',
  downloadLinks: [],
};
